var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwithToTreeMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.20833 2.5C3.71256 2.5 2.5 3.71256 2.5 5.20833V14.7917C2.5 16.2874 3.71256 17.5 5.20833 17.5H12.0833V13.3333H7.91667L7.91667 16.25H5.20833C4.40292 16.25 3.75 15.5971 3.75 14.7917V5.20833C3.75 4.40292 4.40292 3.75 5.20833 3.75H14.7917C15.5971 3.75 16.25 4.40292 16.25 5.20833V7.91667H13.3333V12.0833H17.5V5.20833C17.5 3.71256 16.2874 2.5 14.7917 2.5H5.20833ZM13.3333 13.3333V17.5H14.7917C16.2874 17.5 17.5 16.2874 17.5 14.7917V13.3333H13.3333ZM12.0833 12.0833V7.91667H7.91667L7.91667 12.0833H12.0833Z",
    fill: "#737575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwithToTreeMap);
export default __webpack_public_path__ + "static/media/swith-to-tree-map.d47a9425.svg";
export { ForwardRef as ReactComponent };